import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import './Guest.css';

class Guest extends Component {
  state = {
    attending: this.props.guest.attending,
    meal: this.props.guest.meal,
    info: this.props.guest.info,
    saveEnabled: false,
    savedOpen: false,
    waiting: false,
    name: this.props.guest.first_name + " " + this.props.guest.last_name,
  };

  saveGuest = () => {
    this.setState({saveEnabled: false, savedOpen: true, waiting: true});
    const url = `https://8ddxuiivkd.execute-api.us-east-1.amazonaws.com/production/guest`;
    const nameWords = this.state.name.split(" ");
    let first_name = ""
    let last_name = ""
    if (nameWords.length > 1) {
      first_name = nameWords[0]
      last_name = nameWords.slice(1).join(" ")
    } else {
      first_name = nameWords[0]
      last_name = ""
    }
    const args = JSON.stringify({id: this.props.guest.id, first_name: first_name, last_name: last_name, attending: this.state.attending, meal: this.state.meal, info: this.state.info ? this.state.info : "None"});
    this.getCORS(url, 'POST', args, this.success);
  }

  getCORS = (url, method, args, success) => {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = this.success;
    xhr.send(args);
    return xhr;
  }

  success = (response) => {
    this.setState({waiting: false});
  };

  setAttending = (event, index, attending) => {
    this.setState({attending, saveEnabled: this.saveEnabled()});
  };

  setMeal = (event, index, meal) => {
    this.setState({meal, saveEnabled: this.saveEnabled()})
  };

  setInfo = (event, info) => {
    this.setState({info, saveEnabled: this.saveEnabled()})
  };

  saveEnabled = (currently) => {
    return this.state.attending !== null && this.state.meal !== null;
  };

  handleClose = () => {
     this.setState({savedOpen: false});
  };

  setName = (event) => {
    this.setState({
      name: event.target.value,
      saveEnabled: this.saveEnabled(),
    });
  };

  render() {
    const style = {
      marginLeft: 20,
    };

    const saveDialogStyle = {
      width: '50%',
      maxWidth: '400px',
    };

    const actions = [
      <FlatButton
        label="OK"
        primary={true}
        onTouchTap={this.handleClose}
      />,
    ];

    const rsvpForm =
      <Paper zDepth={2}>
          <TextField
            hintText="Name"
            floatingLabelText="Name"
            style={style}
            underlineShow={false}
            value={this.state.name}
            onChange={this.setName}
          />
          <Divider />
          {this.props.guest && this.props.guest.email &&
            <div>
              <TextField
                hintText="Email address"
                floatingLabelText="Email address"
                style={style}
                underlineShow={false}
                value={this.props.guest ? this.props.guest.email : ""} />
              <Divider />
            </div>
          }
          <SelectField style={style} value={this.state.attending} onChange={this.setAttending} underlineShow={false}
            floatingLabelText="Can you make it?">
            <MenuItem value={"true"} primaryText="Heck yeah! 🕺" />
            <MenuItem value={"false"} primaryText="I'm so sorry 🙇" />
          </SelectField>
          <Divider />
          <SelectField style={style} value={this.state.meal} onChange={this.setMeal} underlineShow={false}
            floatingLabelText="What would you like to eat?">
            <MenuItem value={"beef"} primaryText="Beef (Hanger Steak) 🐄" />
            <MenuItem value={"fish"} primaryText="Fish (Sea Bass) 🐟" />
            <MenuItem value={"veg"} primaryText="Vegetarian (Risotto Cake) 🥕 " />
          </SelectField>
          <Divider />
          <TextField
            floatingLabelText="Dietary restrictions/allergies"
            style={style}
            underlineShow={false}
            value={this.state.info}
            onChange={this.setInfo} />
          <Divider />
          <RaisedButton className="save-button raised-button" primary={true} style={style} label="Save" onClick={this.saveGuest} disabled={!this.state.saveEnabled} />
          <Divider />
        </Paper>

    return (
      <div className="Guest">
        <MuiThemeProvider>
          <div className="guest-form">
            {rsvpForm}
            <Dialog actions={actions} modal={true} contentStyle={saveDialogStyle} open={this.state.savedOpen}>
              { this.state.waiting ? <CircularProgress /> : <div>Your information was saved. Thanks so much!</div> }
            </Dialog>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default Guest;



// WEBPACK FOOTER //
// ./src/Guest.js